var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAdmin)?_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.regenerateBetPeriod}},[_vm._v("Tippschein mit neuen Spielen berechnen")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }